import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'duration',
})
export default class DurationPipe implements PipeTransform {
  transform(value: number, precision?: 'min' | 'sec' /*, format?: string, units?: boolean*/): string {
    if (!value || value <= 0) return '0 min';
    if ((!precision || precision !== 'sec') && value > 0 && value < 60000) return '< 1 min';

    const sec = Math.trunc(value / 1000);
    let duration = '';
    const hour = Math.floor(sec / 3600);
    const minute = Math.floor(sec / 60) % 60;
    if (hour > 0) {
      duration += hour + ' h ';
    }
    if (minute > 0) {
      duration += minute + ' min';
    }
    if (hour === 0 && minute === 0 && value === 60) {
      duration = '1 min';
    }

    if (precision === 'sec' && sec < 60) {
      duration += (duration === '' ? '' : ' ') + sec + 's';
    }

    return duration;
  }
}
